import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import { useNavigate } from "react-router-dom";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link, useParams} from "react-router-dom";
import {
    createCategory,
    resetCreateCategoryStatus
} from "../../store/reducers/CategoriesSlice";
import {RequestStatus} from "../../utils/Enums";
import ElogSelect, {Option} from "../common/form/ElogSelect";
import {getCategoryTypesAll} from "../../store/reducers/CategoryTypesSlice";
import ElogTextarea from "../common/form/ElogTextarea";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface NewCategoryScreenProps {
}

export interface NewCategoryFormProps {
    name: string;
    type: string;
    comment: string;
}

export const NewCategoryScreen: React.FC<NewCategoryScreenProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const categoryTypesState = useAppSelector(state => state.categoryTypes);
    const categoriesState = useAppSelector(state => state.categories);

    const requestStatus: RequestStatus = categoriesState.createCategoryStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: 'Grupid', url: '/categories'},
        {text: 'Lisa uus grupp', url: '/categories/new'},
    ];

    useEffect(() => {
        if ( requestStatus === RequestStatus.Success ) {
            dispatch(resetCreateCategoryStatus());
            navigate(breadcrumbLinks[0].url);
        }

    }, [requestStatus]);

    useEffect(() => {
        dispatch(getCategoryTypesAll());
    }, []);

    const categoryTypesOptions: Option[] = categoryTypesState.categoryTypes.map((category) => ({
        value: category.id.toString(),
        label: category.name,
    }));

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            type: categoryTypesOptions[0]?.value
        },
        onSubmit: (values: any) => {
            dispatch(createCategory(values));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Failed && categoriesState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {categoriesState.errors.map((error, index) => (
                            <span key={index}>{error}<br /></span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2><span>Grupi tüübi andmed</span></h2>
                        <table className="form">
                            <tbody>
                            <ElogInput label="Nimi" name="name" mandatory={true}/>
                            <ElogSelect label="Tüüp" name="type" options={categoryTypesOptions} mandatory={true} />
                            <ElogTextarea label="Kommentaar" name="comment" />
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                <span><strong>Sisesta</strong></span>
                            </button>
                            <Link to="/categories">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    )

}